import { Module } from 'vuex'
import { RootState, LocationMapSearchState } from './state_models'
import { ActionContext } from 'vuex/types/index.js'

export const locationsMapSearch: Module<LocationMapSearchState, RootState> = {
  namespaced: true,
    state: {
        companyId: '',
        places: [],
        searchString: '',
        locationId: '',
        googleSearchResults: [],
        token: '',
        snapshotModal: {
          visible: false,
          snapshot: null,
          source: 'saas'
        }
    },
  getters: {
    getData: (
      state: LocationMapSearchState
    ) => {
      return () => state
    },
  },
  mutations: {
    setData: (state: LocationMapSearchState, payload: Array<{ [key: string]: any }>) => {
      state = Object.assign(state, payload)
    },
  },
  actions: {
   update: {
    handler: (context: ActionContext<LocationMapSearchState, RootState>, payload: object): Promise<any> => {
        return new Promise(async (resolve, reject) => {
            try {
                context.commit('setData', { ...context.state, ...payload });
                resolve(payload);
            } catch (e) {
                reject(e);
            }
        });
    },
   },
   get: {
    handler: (context: ActionContext<LocationMapSearchState, RootState>): Promise<any> => {
        return new Promise(async (resolve) => {
            resolve(context.state);
        });
    },
   }
  }
}
